var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHireIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 61.3334C15.0849 61.3334 18.6666 57.7517 18.6666 53.3334C18.6666 48.9151 15.0849 45.3334 10.6666 45.3334C6.24835 45.3334 2.66663 48.9151 2.66663 53.3334C2.66663 57.7517 6.24835 61.3334 10.6666 61.3334Z",
    fill: "#D5DEFF",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 45.3334H24V61.3334H40V45.3334Z",
    fill: "#D5DEFF",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3334 45.3334L45.3334 61.3334H61.3334L53.3334 45.3334Z",
    fill: "#D5DEFF",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 32H28",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 17.3333C39.9402 15.2305 39.0782 13.2302 37.5907 11.7426C36.1031 10.2551 34.1028 9.39308 32 9.33331C29.8972 9.39308 27.8969 10.2551 26.4093 11.7426C24.9218 13.2302 24.0598 15.2305 24 17.3333C24.03 18.6963 24.4147 20.0279 25.1161 21.197C25.8175 22.366 26.8115 23.3321 28 24V26.6666H36V24C37.1882 23.3317 38.1818 22.3655 38.8832 21.1966C39.5846 20.0276 39.9695 18.6962 40 17.3333Z",
    fill: "#E8DFFB",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 45.3334V38.6667C10.6666 38.3131 10.8071 37.9739 11.0572 37.7239C11.3072 37.4738 11.6463 37.3334 12 37.3334H52C52.3536 37.3334 52.6927 37.4738 52.9428 37.7239C53.1928 37.9739 53.3333 38.3131 53.3333 38.6667V45.3334",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32 32V44",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32 2.66669V5.33335",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3707 6.96265L40.4854 8.84798",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6667 16H44",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6294 6.96265L23.5147 8.84798",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3334 16H20",
    stroke: "#07143F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHireIcon3);
export default __webpack_public_path__ + "static/media/hireIcon3.da9060cee32f81b8eb6e9fc00853d045.svg";
export { ForwardRef as ReactComponent };